import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

interface LocalServiceUpdateModalProps {
  open: boolean;
  version: string;
  onRestart: () => Promise<boolean>;
  onClose: () => void;
}

const LocalServiceUpdateModal: React.FC<LocalServiceUpdateModalProps> = ({
  open,
  version,
  onRestart,
  onClose,
}) => {
  const [isRestarting, setIsRestarting] = useState(false);

  const handleRestart = async () => {
    setIsRestarting(true);
    const success = await onRestart();
    if (success) {
      onClose();
    }
    setTimeout(() => setIsRestarting(false), 5000);
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          bgcolor: 'info.main',
          color: 'info.contrastText',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <SystemUpdateAltIcon />
        Local Servis Guncellemesi
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ textAlign: 'center', py: 1 }}>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
            Local servis sisteminde guncelleme mevcut{version ? ` (v${version})` : ''}.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Lutfen yeniden baslatin.
          </Typography>
          <Box
            sx={{
              bgcolor: 'grey.100',
              p: 2,
              borderRadius: 1,
              mt: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Eger bu guncellemeyi simdi yapmak istemezseniz, bilgisayar veya
              local service kapatildigi zaman sistem yeniden acildiginda
              guncelleme otomatik olarak uygulanacaktir.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={isRestarting}>
          Sonra
        </Button>
        <Button
          onClick={handleRestart}
          variant="contained"
          color="success"
          disabled={isRestarting}
          startIcon={isRestarting ? <CircularProgress size={18} color="inherit" /> : <SystemUpdateAltIcon />}
          sx={{ fontWeight: 'bold' }}
        >
          {isRestarting ? 'Yeniden Baslatiliyor...' : 'Yeniden Baslat'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocalServiceUpdateModal;
